import store from '@src/state/store'
import { DOMAIN_TITLE } from '@src/constants/general-constants'
import defaultLogo from '@src/assets/images/logo.svg'
import { PWA_HARD_RELOAD_TIMEOUT } from '@src/constants/layout-constant.js'

var manifestJSON = {
  name: DOMAIN_TITLE,
  short_name: DOMAIN_TITLE,
  start_url: window.location.href,
  display: 'standalone',
  icons: [
    {
      src: defaultLogo,
      type: 'image/svg+xml',
      sizes: 'any',
      purpose: 'any',
    },
    {
      src: defaultLogo,
      type: 'image/svg+xml',
      sizes: '192x192',
      purpose: 'any maskable',
    },
    {
      src: defaultLogo,
      type: 'image/svg+xml',
      sizes: '512x512',
      purpose: 'any maskable',
    },
    {
      src: defaultLogo,
      type: 'image/svg+xml',
      sizes: '180x180',
      purpose: 'any',
    },
    {
      src: defaultLogo,
      type: 'image/svg+xml',
      sizes: '152x152',
      purpose: 'any',
    },
    {
      src: defaultLogo,
      type: 'image/svg+xml',
      sizes: '144x144',
      purpose: 'any',
    },
  ],
  screenshots: [
    {
      src: defaultLogo,
      type: 'image/png',
      sizes: '1240x600',
      form_factor: 'wide',
    },
    {
      src: defaultLogo,
      type: 'image/png',
      sizes: '620x300',
      form_factor: 'narrow',
    },
  ],
  theme_color: '#ffffff',
  background_color: '#ffffff',
  orientation: 'portrait',
  description: 'You can serve MyQampus as Application',
}

function setPWA() {
  manifestJSON.start_url = window.location.href
  manifestJSON.name = store.getters['layout/instituteTitle']
  manifestJSON.short_name = store.getters['layout/instituteTitle']

  // Update icons with dynamic logo if available, otherwise use default PWA icons
  const instituteLogo = store.getters['layout/instituteLogo']
  if (instituteLogo && instituteLogo !== defaultLogo) {
    manifestJSON.icons = manifestJSON.icons.map(function (element, index, iconList) {
      return {
        type: iconList[index].type,
        src: instituteLogo,
        sizes: iconList[index].sizes,
        purpose: iconList[index].purpose,
      }
    })

    // Also update screenshots with dynamic logo
    manifestJSON.screenshots = manifestJSON.screenshots.map(function (
      element,
      index,
      screenshotList,
    ) {
      return {
        src: instituteLogo,
        type: 'image/svg+xml', // Changed to match SVG format
        sizes: screenshotList[index].sizes,
        form_factor: screenshotList[index].form_factor,
      }
    })
  }

  const stringManifest = JSON.stringify(manifestJSON)

  const blob = new Blob([stringManifest], { type: 'application/json' })
  const manifestURL = URL.createObjectURL(blob)

  document.querySelector('#dynamic-menifest').setAttribute('href', manifestURL)
}

export function isPWAInstallable() {
  return 'serviceWorker' in navigator && 'PushManager' in window && window.deferredPrompt !== null
}

export function isPWARunning() {
  const isStandaloneDisplay = window.matchMedia('(display-mode: standalone)').matches
  const isIOSStandalone = window?.navigator?.standalone === true
  const isDesktopPWA = window.matchMedia('(display-mode: window-controls-overlay)').matches

  return isStandaloneDisplay || isIOSStandalone || isDesktopPWA
}

export function setupPWAInstallListener() {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    window.deferredPrompt = e
  })

  window.addEventListener('appinstalled', (evt) => {
    window.deferredPrompt = null
    // Hard refresh after PWA installation with delay
    setTimeout(() => {
      window.location.reload(true)
    }, PWA_HARD_RELOAD_TIMEOUT)
  })
}

export default setPWA
